import { render } from "./receipt-report.vue?vue&type=template&id=34b69226&ts=true&ref=template"
import script from "./receipt-report.vue?vue&type=script&lang=ts"
export * from "./receipt-report.vue?vue&type=script&lang=ts"

import "./receipt-report.vue?vue&type=style&index=0&id=34b69226&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__